import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { memo, useContext, useMemo, } from 'react';
import { createPortal } from 'react-dom';
import { ReactPortalContext } from './ReactPortalContext';
const defaultProps = {
    isNode: false,
};
const ReactPortal = ({ children, isNode = defaultProps.isNode, }) => {
    const { emotionCacheKey, emotionTargetContainer, hasNewEmotionCache, targetElement = (typeof document === 'undefined' ? null : document.body), } = (useContext(ReactPortalContext)
        || {});
    const hasDocument = (useMemo(() => (!isNode
        && typeof document !== 'undefined'), [
        isNode,
    ]));
    const emotionCache = (useMemo(() => (hasNewEmotionCache
        ? (createCache({
            container: emotionTargetContainer,
            key: emotionCacheKey,
        }))
        : null), 
    // If we add any dependencies, we'll see memory leaks from Emotion continually creating new caches. Ideally, this would remove the old cache when creating a new one. As of `@emotion/cache@^10.0.19`, there's no way of removing the old cache.
    [] // eslint-disable-line react-hooks/exhaustive-deps
    // [
    //   emotionTargetContainer,
    //   emotionCacheKey,
    //   hasNewEmotionCache,
    // ]
    ));
    return (hasDocument
        ? (createPortal((hasNewEmotionCache
            && emotionCache !== null
            ? (
            // This `CacheProvider` allows `ReactPortal` to be used in other contexts such as an `iframe` rendering out to the parent document.
            // If you're scoping Emotion styles to a DOM node that's not `document.body`, this is another reason you'd want to add a `CacheProvider` as anything rendering to the `body` wouldn't have scoped styles.
            _jsx(CacheProvider
            // @ts-ignore 2741
            , Object.assign({ 
                // @ts-ignore 2741
                value: emotionCache }, { children: children })))
            : children), targetElement))
        : null);
};
const MemoizedReactPortal = memo(ReactPortal);
export { MemoizedReactPortal as ReactPortal };
// MC-1068 Temporary hack for Storybook.
export default ReactPortal;
